// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandSummaryComponent } from './components/brand-summary/brand-summary.component';
import { TranslateModule } from '@ngx-translate/core';
import { PercentageChangeModule } from '../percentage-change/percentage-change.module';
import { IconTooltipModule } from '../icon-tooltip/icon-tooltip.module';
import { BrandSummarySkeletonComponent } from './skeleton/brand-summary-skeleton/brand-summary-skeleton.component';
import { FeatureToggleModule } from '@coa/app/shared/feature-toggle/feature-toggle.module';


@NgModule({
  declarations: [BrandSummaryComponent, BrandSummarySkeletonComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    PercentageChangeModule,
    IconTooltipModule,
    FeatureToggleModule,
  ],
  exports: [
    BrandSummaryComponent,
    BrandSummarySkeletonComponent,
  ],
})
export class BrandSummaryModule {
}
